module.exports = __webpack_public_path__ + "static/media/Acrilico (27).106d10e0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/fotos/Acrilico/Acrilico (27).jpg
// module id = 295
// module chunks = 0